"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Layout_helpers_1 = require("../Layout.helpers");
const StyledItem = styled_components_1.default.div `
    ${({ flex }) => flex && (0, Layout_helpers_1.toMediaCssObject)("flex", flex)}
`;
/**
 * Layout component that would reflect CSS Flexbox (Children items)
 * @param flex - shorthand for flex-grow, flex-shrink and flex-basis combined (eg: "1" or "1 0 100%").
 *
 * @deprecated please use <Ds.Flex.Item> instead
 */
exports.Item = (0, react_1.forwardRef)(({ as, children, className, flex }, forwardedRef) => (react_1.default.createElement(StyledItem, { as: as, className: className, flex: flex, ref: forwardedRef }, children)));
//# sourceMappingURL=Item.js.map